// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/crud/admin_user_crud_service_generated.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { AdminUser } from "../../../entity/admin_user_pb";

/**
 * IndexAdminUserArgs メッセージ
 *
 * @generated from message service.IndexAdminUserArgs
 */
export class IndexAdminUserArgs extends Message<IndexAdminUserArgs> {
  /**
   * @generated from field: int32 offset = 1;
   */
  offset = 0;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<IndexAdminUserArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexAdminUserArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexAdminUserArgs {
    return new IndexAdminUserArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexAdminUserArgs {
    return new IndexAdminUserArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexAdminUserArgs {
    return new IndexAdminUserArgs().fromJsonString(jsonString, options);
  }

  static equals(a: IndexAdminUserArgs | PlainMessage<IndexAdminUserArgs> | undefined, b: IndexAdminUserArgs | PlainMessage<IndexAdminUserArgs> | undefined): boolean {
    return proto3.util.equals(IndexAdminUserArgs, a, b);
  }
}

/**
 * CreateAdminUserArgs メッセージ
 *
 * @generated from message service.CreateAdminUserArgs
 */
export class CreateAdminUserArgs extends Message<CreateAdminUserArgs> {
  /**
   * @generated from field: repeated entity.AdminUser admin_users = 1 [json_name = "admin_users"];
   */
  adminUsers: AdminUser[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 3 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<CreateAdminUserArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateAdminUserArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "admin_users", jsonName: "admin_users", kind: "message", T: AdminUser, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAdminUserArgs {
    return new CreateAdminUserArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAdminUserArgs {
    return new CreateAdminUserArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAdminUserArgs {
    return new CreateAdminUserArgs().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAdminUserArgs | PlainMessage<CreateAdminUserArgs> | undefined, b: CreateAdminUserArgs | PlainMessage<CreateAdminUserArgs> | undefined): boolean {
    return proto3.util.equals(CreateAdminUserArgs, a, b);
  }
}

/**
 * ReadAdminUserArgs メッセージ
 *
 * @generated from message service.ReadAdminUserArgs
 */
export class ReadAdminUserArgs extends Message<ReadAdminUserArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  constructor(data?: PartialMessage<ReadAdminUserArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadAdminUserArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadAdminUserArgs {
    return new ReadAdminUserArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadAdminUserArgs {
    return new ReadAdminUserArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadAdminUserArgs {
    return new ReadAdminUserArgs().fromJsonString(jsonString, options);
  }

  static equals(a: ReadAdminUserArgs | PlainMessage<ReadAdminUserArgs> | undefined, b: ReadAdminUserArgs | PlainMessage<ReadAdminUserArgs> | undefined): boolean {
    return proto3.util.equals(ReadAdminUserArgs, a, b);
  }
}

/**
 * UpdateAdminUserArgs メッセージ
 *
 * @generated from message service.UpdateAdminUserArgs
 */
export class UpdateAdminUserArgs extends Message<UpdateAdminUserArgs> {
  /**
   * @generated from field: repeated entity.AdminUser admin_users = 1 [json_name = "admin_users"];
   */
  adminUsers: AdminUser[] = [];

  /**
   * @generated from field: bool allow_missing = 2 [json_name = "allow_missing"];
   */
  allowMissing = false;

  /**
   * @generated from field: bool force_execute = 3 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 4 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<UpdateAdminUserArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateAdminUserArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "admin_users", jsonName: "admin_users", kind: "message", T: AdminUser, repeated: true },
    { no: 2, name: "allow_missing", jsonName: "allow_missing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAdminUserArgs {
    return new UpdateAdminUserArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAdminUserArgs {
    return new UpdateAdminUserArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAdminUserArgs {
    return new UpdateAdminUserArgs().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAdminUserArgs | PlainMessage<UpdateAdminUserArgs> | undefined, b: UpdateAdminUserArgs | PlainMessage<UpdateAdminUserArgs> | undefined): boolean {
    return proto3.util.equals(UpdateAdminUserArgs, a, b);
  }
}

/**
 * DeleteAdminUserArgs メッセージ
 *
 * @generated from message service.DeleteAdminUserArgs
 */
export class DeleteAdminUserArgs extends Message<DeleteAdminUserArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  constructor(data?: PartialMessage<DeleteAdminUserArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteAdminUserArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAdminUserArgs {
    return new DeleteAdminUserArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAdminUserArgs {
    return new DeleteAdminUserArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAdminUserArgs {
    return new DeleteAdminUserArgs().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAdminUserArgs | PlainMessage<DeleteAdminUserArgs> | undefined, b: DeleteAdminUserArgs | PlainMessage<DeleteAdminUserArgs> | undefined): boolean {
    return proto3.util.equals(DeleteAdminUserArgs, a, b);
  }
}

/**
 * IndexAdminUserReply メッセージ
 *
 * @generated from message service.IndexAdminUserReply
 */
export class IndexAdminUserReply extends Message<IndexAdminUserReply> {
  /**
   * @generated from field: repeated entity.AdminUser admin_users = 1 [json_name = "admin_users"];
   */
  adminUsers: AdminUser[] = [];

  constructor(data?: PartialMessage<IndexAdminUserReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexAdminUserReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "admin_users", jsonName: "admin_users", kind: "message", T: AdminUser, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexAdminUserReply {
    return new IndexAdminUserReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexAdminUserReply {
    return new IndexAdminUserReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexAdminUserReply {
    return new IndexAdminUserReply().fromJsonString(jsonString, options);
  }

  static equals(a: IndexAdminUserReply | PlainMessage<IndexAdminUserReply> | undefined, b: IndexAdminUserReply | PlainMessage<IndexAdminUserReply> | undefined): boolean {
    return proto3.util.equals(IndexAdminUserReply, a, b);
  }
}

/**
 * CreateAdminUserReply メッセージ
 *
 * @generated from message service.CreateAdminUserReply
 */
export class CreateAdminUserReply extends Message<CreateAdminUserReply> {
  constructor(data?: PartialMessage<CreateAdminUserReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateAdminUserReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAdminUserReply {
    return new CreateAdminUserReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAdminUserReply {
    return new CreateAdminUserReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAdminUserReply {
    return new CreateAdminUserReply().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAdminUserReply | PlainMessage<CreateAdminUserReply> | undefined, b: CreateAdminUserReply | PlainMessage<CreateAdminUserReply> | undefined): boolean {
    return proto3.util.equals(CreateAdminUserReply, a, b);
  }
}

/**
 * ReadAdminUserReply メッセージ
 *
 * @generated from message service.ReadAdminUserReply
 */
export class ReadAdminUserReply extends Message<ReadAdminUserReply> {
  /**
   * @generated from field: repeated entity.AdminUser admin_users = 1 [json_name = "admin_users"];
   */
  adminUsers: AdminUser[] = [];

  constructor(data?: PartialMessage<ReadAdminUserReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadAdminUserReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "admin_users", jsonName: "admin_users", kind: "message", T: AdminUser, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadAdminUserReply {
    return new ReadAdminUserReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadAdminUserReply {
    return new ReadAdminUserReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadAdminUserReply {
    return new ReadAdminUserReply().fromJsonString(jsonString, options);
  }

  static equals(a: ReadAdminUserReply | PlainMessage<ReadAdminUserReply> | undefined, b: ReadAdminUserReply | PlainMessage<ReadAdminUserReply> | undefined): boolean {
    return proto3.util.equals(ReadAdminUserReply, a, b);
  }
}

/**
 * UpdateAdminUserReply メッセージ
 *
 * @generated from message service.UpdateAdminUserReply
 */
export class UpdateAdminUserReply extends Message<UpdateAdminUserReply> {
  constructor(data?: PartialMessage<UpdateAdminUserReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateAdminUserReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAdminUserReply {
    return new UpdateAdminUserReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAdminUserReply {
    return new UpdateAdminUserReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAdminUserReply {
    return new UpdateAdminUserReply().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAdminUserReply | PlainMessage<UpdateAdminUserReply> | undefined, b: UpdateAdminUserReply | PlainMessage<UpdateAdminUserReply> | undefined): boolean {
    return proto3.util.equals(UpdateAdminUserReply, a, b);
  }
}

/**
 * DeleteAdminUserReply メッセージ
 *
 * @generated from message service.DeleteAdminUserReply
 */
export class DeleteAdminUserReply extends Message<DeleteAdminUserReply> {
  constructor(data?: PartialMessage<DeleteAdminUserReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteAdminUserReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAdminUserReply {
    return new DeleteAdminUserReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAdminUserReply {
    return new DeleteAdminUserReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAdminUserReply {
    return new DeleteAdminUserReply().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAdminUserReply | PlainMessage<DeleteAdminUserReply> | undefined, b: DeleteAdminUserReply | PlainMessage<DeleteAdminUserReply> | undefined): boolean {
    return proto3.util.equals(DeleteAdminUserReply, a, b);
  }
}

